import React, { useState } from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react"
import Modal from "/src/components/modal/Modal";
import ButtonAction from "/src/components/UI/Button/Button";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import Form from "/src/components/form/Form";
import statementService from '/src/features/dataset/services/statementService';
import "./ImportModal.css";
import "/src/assets/css/polices.css";
import ChooseFile from "/src/components/UI/ChooseFile/ChooseFile";
import { useToastDispatchContext } from "/src/layouts/toast/context/toastContext";
import SpanToast from '/src/layouts/toast/components/SpanToast';

const ImportModalJson = NiceModal.create(({ nameDataset, title, data }) => {
    const modal = useModal();

    const { onClose } = useModalHelper(modal);
    const [file, setFile] = useState(null);
    const [loadAnim, setLoading] = useState(null);

    const toast = useToastDispatchContext();

    const onSubmit = async () => {
        if (!file) return;
    
        try {
            setLoading(true);
            const text = await file.text();
            const jsonData = JSON.parse(text);
    
            // on check si les redirs sont bien
            if (!jsonData.redirections || !Array.isArray(jsonData.redirections)) {
                throw new Error("Invalid JSON format. Expected an object with a 'redirections' array.");
            }
    
            setLoading("finish");
            setTimeout(() => {
                // On envoie l’objet complet { variable, variable_redirection, redirections }
                modal.resolve(jsonData);
                onClose();
            }, 1000);
    
        } catch (err) {
            onClose();
            toast.error('Error', <SpanToast text={err.message} />, 7000);
        }
    };
    

    return (
        <Modal name="import-json" id={modal.id} autoClose="true" onClose={onClose}>
            <div className="leave-container">
                <div className="button-leave" id="close_modal_container" onClick={() => onClose({ idIconModal: "close_modal_container" })} >
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>
            <Form className="form-import">
                <Form.Title>Import your JSON data</Form.Title>
                <div className="container_import">
                    <Form.Body className="form-import_body">
                        <ChooseFile _setFile={setFile} accept=".json" loadAnim={loadAnim}></ChooseFile>
                    </Form.Body>
                </div>
                <Form.Buttons>
                    <div className="button_center">
                        <ButtonAction
                            className="validate"
                            label="Upload JSON"
                            disabled={!file}
                            onClick={() => { onSubmit(); setLoading(true); }}
                        />
                    </div>
                </Form.Buttons>
            </Form>
        </Modal>
    )
});

export default ImportModalJson;
